export const TECH_TALENT_CATEGORY_IDS = [46, 47, 48, 49, 50, 51, 52, 53]

export const TECH_TALENT_CATEGORIES = [
	{ id: 46, name: 'Data and Artificial Intelligence' },
	{ id: 47, name: 'Infrastructure' },
	{ id: 48, name: 'Software and Applications' },
	{ id: 49, name: 'Strategy and Governance' },
	{ id: 50, name: 'Operations and Support' },
	{ id: 51, name: 'Cyber Security' },
	{ id: 52, name: 'Sales and Marketing' },
	{ id: 53, name: 'Product Development' }
]

// query to fetch categories with job counts for a specific event (and optionally a company)
export const getCategoriesWithJobCountsQuery = (eventId: number, companyId?: number) => {
	const whereClause = companyId 
		? `eventID: {_eq: ${eventId}}, companyId: {_eq: ${companyId}}`
		: `eventID: {_eq: ${eventId}}`
	
	return `
	query {
		Category(where: {
			id: {_in: [${TECH_TALENT_CATEGORY_IDS.join(',')}]}
		}) {
			id
			name
			Jobs_aggregate(where: {
				${whereClause}
			}) {
				aggregate {
					count
				}
			}
		}
	}
`
}

export const processCategoriesWithCounts = (categoriesData: any[]) => {
	const categoryJobCounts: { [key: number]: number } = {}
	const categories = categoriesData.map((cat: any) => {
		const jobCount = cat.Jobs_aggregate?.aggregate?.count || 0
		categoryJobCounts[cat.id] = jobCount
		return {
			id: cat.id,
			name: cat.name
		}
	})

	return { categories, categoryJobCounts }
}